export const updateAlert = (alertType, alertMessage, time = 2500) => (dispatch) => {
  dispatch({
    type: "showAlert",
    value: {
      alertType,
      alertMessage
    }
  });
  setTimeout(() => {
    dispatch({
      type: "closeAlert"
    })
  }, time)
}

export const updateProjects = (projects) => (dispatch) => {
  dispatch({
    type: "saveProjects",
    value: {
      projects
    }
  })
}

export const updateUnapprovedProjects = (projects) => (dispatch) => {
  dispatch({
    type: "saveUnapprovedProjects",
    value: {
      projects
    }
  })
}

export const updateProjectNamesAndIdsOfUser = (projectNamesAndIdsOfUser) => (dispatch) => {
  dispatch({
    type: "saveProjectNamesAndIdsOfUser",
    value: {
      projectNamesAndIdsOfUser
    }
  })
}

export const updateModels = (models) => (dispatch) => {
  dispatch({
    type: "saveModels",
    value: {
      models
    }
  })
}

export const updateUnapprovedModels = (models) => (dispatch) => {
  dispatch({
    type: "saveUnapprovedModels",
    value: {
      models
    }
  })
}

export const updateModelInputTypes = (modelInputTypes) => (dispatch) => {
  dispatch({
    type: "saveModelInputTypes",
    value: {
      modelInputTypes
    }
  })
}

export const updateModelResultTypes = (modelResultTypes) => (dispatch) => {
  dispatch({
    type: "saveModelResultTypes",
    value: {
      modelResultTypes
    }
  })
}

export const updateUsers = (users) => (dispatch) => {
  dispatch({
    type: "saveUsers",
    value: {
      users
    }
  })
}

export const updateAdminProjects = (adminProjects) => (dispatch) => {
  dispatch({
    type: "saveAdminProjects",
    value: {
      adminProjects
    }
  })
}

export const updateAdminModels = (adminModels) => (dispatch) => {
  dispatch({
    type: "saveAdminModels",
    value: {
      adminModels
    }
  })
}

export const updateRole = (role) => (dispatch) => {
  dispatch({
    type: "updateRole",
    value: {
      role
    }
  })
}